var PI=3.1415926535897932384626;
var a = 6378245.0;
var ee = 0.00669342162296594323;
export default {
    init(){
        return new Promise((resolve,reject)=>{
            if(window.T){
                resolve(window.T)
                reject('error')
            }
        })
    },
    transformlat(lng, lat) {
      var lat = +lat;
      var lng = +lng;
      var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
      ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0;
      ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0;
      return ret
    },
    transformlng(lng, lat) {
      var lat = +lat;
      var lng = +lng;
      var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
      ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0;
      ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0;
      return ret
    },
    /* gcj02towgs84 */
    getLngLat(lng, lat) {
      var lat = +lat;
      var lng = +lng;
      var dlat = this.transformlat(lng - 105.0, lat - 35.0);
      var dlng = this.transformlng(lng - 105.0, lat - 35.0);
      var radlat = lat / 180.0 * PI;
      var magic = Math.sin(radlat);
      magic = 1 - ee * magic * magic;
      var sqrtmagic = Math.sqrt(magic);
      dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
      dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
      var mglat = lat + dlat;
      var mglng = lng + dlng;

      return [lng * 2 - mglng, lat * 2 - mglat]
    },
    filterMarkers(res,type){
      var arr=[];
      if(type == 1){
        for (var i = 0; i < res.length; i++) {
          if(res[i].name.indexOf('-地铁站')>-1){
            res[i].name=res[i].name.split('-地铁站')[0]
            arr.push(res[i])
          }
          if(arr.length>9){ break; }
        }
      }else if(type == 2){
        for (var i = 0; i < res.length; i++) {
          if(res[i].name.indexOf('报名')<0&&res[i].name.indexOf('充电站')<0&&res[i].name.indexOf('培训')<0&&res[i].name.indexOf('专卖店')<0&&res[i].name.indexOf('东门')<0&&res[i].name.indexOf('西门')<0&&res[i].name.indexOf('南门')<0&&res[i].name.indexOf('北门')<0){
            arr.push(res[i])
          }
          if(arr.length>9){ break; }
        }
      }else if(type == 3){
        for (var i = 0; i < res.length; i++) {
          if(res[i].name.indexOf('院-')<0&&res[i].name.indexOf('停车场')<0&&res[i].name.indexOf('东门')<0&&res[i].name.indexOf('西门')<0&&res[i].name.indexOf('南门')<0&&res[i].name.indexOf('北门')<0){
            arr.push(res[i])
          }
          if(arr.length>9){ break; }
        }
      }else if(type == 4){
        for (var i = 0; i < res.length; i++) {
          if(res[i].name.indexOf('餐厅')<0&&res[i].name.indexOf('自提柜')<0&&res[i].name.indexOf('停车场')<0&&res[i].name.indexOf('东门')<0&&res[i].name.indexOf('西门')<0&&res[i].name.indexOf('南门')<0&&res[i].name.indexOf('北门')<0){
            arr.push(res[i])
          }
          if(arr.length>9){ break; }
        }
      }else{
        for (var i = 0; i < res.length; i++) {
          if(res[i].name.indexOf('-公交站')>-1){
            res[i].name=res[i].name.split('-公交站')[0]
            arr.push(res[i])
          }
          if(arr.length>9){ break; }
        }
      }
      return arr;
    }

}



// WEBPACK FOOTER //
// ./src/store/tianMap.js